<div>
    <div [formGroup]="form">

        <div [ngSwitch]="question.controlType">
            <div *ngSwitchCase="'oneline'" class="form-group pad-top-half pad-left pad-right">
                <div class="row" *ngIf="required">
                   <div *ngIf="!shouldIndent" class="column1 question-label"><span *ngIf="isNumbered">{{qId}}.</span></div>
                   <div class="column2 question-label">{{question.label}}<span style="color: red;">*</span></div>
                </div>                    
                <div *ngIf="required && !shouldIndent" class="pad-top-half width85 margin-left">
                   <input [formControlName]="question.key" [id]="question.key" [type]="question.type" class="form-control text-label" autocomplete="off">
                </div>
                <div *ngIf="required && shouldIndent" class="pad-top-half width91">
                   <input [formControlName]="question.key" [id]="question.key" [type]="question.type" class="form-control text-label" autocomplete="off">
                </div>
                <div *ngIf="required && !shouldIndent && hint" class="width85 pad-left-more">
                   <span class="text-label-hint">{{hint}}</span>
                </div>
                <div *ngIf="required && shouldIndent && hint" class="pad-left-half">
                   <span class="text-label-hint">{{hint}}</span>
                </div>
                <div class="row" *ngIf="!required">
                   <div class="row width50">
                      <div *ngIf="shouldIndent" class="column1 question-label">
                         <span *ngIf="isNumbered && !isSubnumbered">{{qId}}.</span>
                         <span *ngIf="isNumbered && isSubnumbered">{{qId}} (i).</span>
                         <span *ngIf="!isNumbered && !isSubnumbered"></span>
                         <span *ngIf="!isNumbered && isSubnumbered">{{qId}} (i).</span>
                      </div>
                      <div class="column2 question-label">{{question.label}}</div>
                   </div>
                   <div class="row width50">
                      <div class="width85" *ngIf="!required">
                         <input [formControlName]="question.key" [placeholder]="placeholder" [id]="question.key" [type]="question.type" autocomplete="off" class="form-control-sameline text-label">
                      </div>
                      <div class="width85" *ngIf="!required && hint">
                         <span class="text-label">{{hint}}</span>
                      </div>
                   </div>
                </div>
                <div *ngIf="!submitted && !isValid && !isBlank && (isTouched || isDirty) && patternError" class="alert alert-danger text-label">
                        <ng-container *ngIf="question.validation === 'alpha'">
                            <span class="text-label2">Only alphabets are allowed</span>
                        </ng-container>
                        <ng-container *ngIf="question.validation === 'numeric'">
                            <span class="text-label2">Only numeric values are allowed</span>
                        </ng-container>
                        <ng-container *ngIf="question.validation === 'alpha-numeric'">
                            <span class="text-label2">Only alpha-numeric values are allowed</span>
                        </ng-container>
                </div>
                <div *ngIf="!submitted && !isValid && (isTouched || isDirty) && question.required" class="alert alert-danger">
                  <span class="text-label">This field is required</span>
                </div>
                <div *ngIf="!submitted && !isBlank && (isTouched || isDirty) && question.validation === 'email' && emailBusinessError" class="alert alert-danger">
                  <span class="text-label">Only valid e-mail addresses are allowed</span>
                </div>
            </div>

            <div *ngSwitchCase="'dropdown'" class="form-check pad-top pad-left pad-right">
                <div class="row">
                  <div *ngIf="!shouldIndent" class="column1 question-label">
                    <span *ngIf="isNumbered && !isSubnumbered">{{qId}}.</span>
                    <span *ngIf="isNumbered && isSubnumbered">{{qId}} (i).</span>
                    <span *ngIf="!isNumbered && !isSubnumbered"></span>
                    <span *ngIf="!isNumbered && isSubnumbered">{{qId}} (i).</span>
                  </div>
                  <div class="column2 question-label">{{question.label}}<span *ngIf="required" style="color: red;">*</span></div>
                </div>
                <div *ngIf="required && shouldIndent" class="pad-top-half width89">
                   <mat-select class="text-label" [formControlName]="question.key" [value]="selectedOption" disableOptionCentering="true" placeholder="Choose an option" (selectionChange)="selected($event, question)">
                      <mat-option *ngFor="let option of question.options;" [id]="option.key" [value]="option.key">
                         <span class="text-label">{{option.value}}</span>
                      </mat-option>
                   </mat-select>
                </div>
                <div *ngIf="required && !shouldIndent" class="pad-top-half width86 margin-left">
                   <mat-select class="text-label" [formControlName]="question.key" [value]="selectedOption" disableOptionCentering="true" placeholder="Choose an option" (selectionChange)="selected($event, question)">
                      <mat-option *ngFor="let option of question.options;" [id]="option.key" [value]="option.key">
                         <span class="text-label">{{option.value}}</span>
                      </mat-option>
                   </mat-select>
                </div>
            </div>

            <div *ngSwitchCase="'multiline'" class="form-group pad-top pad-left pad-right">
                <label class="control-label" [for]="question.key">
                    <div class="row">
                       <div class="column1 question-label"><span *ngIf="isNumbered">{{qId}}.</span></div>
                       <div class="column2 question-label">{{question.label}}<span *ngShow="required" style="color: red;">*</span></div>
                    </div>
                </label>
                <textarea class="text-label" [formControlName]="question.key" cols="30" rows="5" autocomplete="off" [id]="question.key"
                    class="form-control pad margin-left-more"></textarea>
                <div *ngIf="!submitted && !isValid && (isTouched || isDirty)" class="alert alert-danger">
                    <ng-container *ngIf="patternError; else requiredError">
                        <ng-container *ngIf="question.validation === 'alpha'">
                            <span class="text-label">Only alphabets are allowed</span>
                        </ng-container>
                        <ng-container *ngIf="question.validation === 'numeric'">
                            <span class="text-label">Only numeric values are allowed</span>
                        </ng-container>
                        <ng-container *ngIf="question.validation === 'alpha-numeric'">
                            <span class="text-label">only alpha-numeric values are allowed</span>
                        </ng-container>
                    </ng-container>
                    <ng-template #requiredError>
                        <span class="text-label">This field is required</span>
                    </ng-template>
                </div>
            </div>

            <div *ngSwitchCase="'radio'" class="form-check pad-top pad-right pad-left">
                <div class="row">
                  <div *ngIf="isNumbered && !isSubnumbered" class="column1 question-label">
                    <span>{{qId}}.</span>
                  </div>
                  <div *ngIf="isNumbered && isSubnumbered" class="column1 question-label">
                    <span>{{qId}}. (i)</span>
                  </div>
                  <div *ngIf="!isNumbered && isSubnumbered" class="column1 question-label">
                    <span>{{qId}}. (i)</span>
                  </div>
                  <div class="column2 question-label"><span [innerHTML]="insertMarker(question.label, question.key)"></span><span *ngIf="required" style="color: red;">*</span></div>
                </div>
                <div *ngIf="isNumbered" class="responsive-three-column-grid pad-left-more row2">
                  <div *ngFor="let option of question.options; index as idx">
                    <ng-container *ngIf="idx === 0; else notChecked">
                       <div class="row3">
                         <div class="column3">
                           <input [formControlName]="question.key" [id]="option.key" type="radio" [value]="option.key"
                             class="form-check-input" checked>
                         </div>
                         <div class="column4">
                           <label [for]="option.key" class="form-check-label">
                             <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-container>
                    <ng-template #notChecked>
                       <div class="row3">
                         <div class="column3">
                           <input [formControlName]="question.key" [id]="option.key" type="radio" [value]="option.key"
                             class="form-check-input">
                         </div>
                         <div class="column4">
                           <label [for]="option.key" class="form-check-label">
                            <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-template>
                  </div>
                </div>
                <div *ngIf="!isNumbered" class="responsive-three-column-grid row2">
                  <div *ngFor="let option of question.options; index as idx">
                    <ng-container *ngIf="idx === 0; else notChecked">
                       <div class="row3">
                         <div class="column3">
                           <input [formControlName]="question.key" [id]="option.key" type="radio" [value]="option.key"
                             class="form-check-input" checked>
                         </div>
                         <div class="column4">
                           <label [for]="option.key" class="form-check-label">
                             <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-container>
                    <ng-template #notChecked>
                       <div class="row3">
                         <div class="column3">
                           <input [formControlName]="question.key" [id]="option.key" type="radio" [value]="option.key"
                             class="form-check-input">
                         </div>
                         <div class="column4">
                           <label [for]="option.key" class="form-check-label">
                            <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-template>
                  </div>
                </div>
            </div>

            <div *ngSwitchCase="'checkbox'" class="form-check pad-top pad-left">
              <div *ngIf="question.options.length > 1">
                <div class="row">
                  <div class="column1 question-label">
                    <span *ngIf="isNumbered && !isSubnumbered">{{qId}}.</span>
                    <span *ngIf="isNumbered && isSubnumbered">{{qId}} (i).</span>
                    <span *ngIf="!isNumbered && !isSubnumbered"></span>
                    <span *ngIf="!isNumbered && isSubnumbered">{{qId}} (i).</span>
                  </div>
                  <div class="column2 question-label">{{question.label}}<span *ngIf="required" style="color: red;">*</span></div>
                </div>
                <div *ngIf="!isNumbered" class="pad-left-more pad-top-half width85">
                   <mat-select class="text-label" [id]="question.key" [formControlName]="question.key" multiple [value]="selectedOptions" disableOptionCentering panelClass="select-panel" placeholder="Choose an option" (selectionChange)="selected($event, question)">
                      <mat-select-trigger>
                         <span *ngIf="selectedCount == 1" class="text-label">1 option selected</span>
                         <span *ngIf="selectedCount > 1" class="text-label">{{selectedCount}} options selected</span>
                         <span *ngIf="selectedCount == 0" class="text-label">Choose an option</span>
                      </mat-select-trigger>
                      <mat-option *ngFor="let option of question.options;" [id]="option.key" [value]="option.key">
                         <span class="text-label">{{option.value}}</span>
                      </mat-option>
                   </mat-select>
                </div>
                <div *ngIf="isNumbered" class="pad-top-half">
                   <mat-select class="text-label" [id]="question.key" [formControlName]="question.key" multiple [value]="selectedOptions" disableOptionCentering panelClass="select-panel" placeholder="Choose an option" (selectionChange)="selected($event, question)">
                      <mat-option *ngFor="let option of question.options;" [id]="option.key" [value]="option.key">
                         <span class="text-label">{{option.value}}</span>
                      </mat-option>
                   </mat-select>
                </div>
                <div *ngIf="!submitted && !isValid && (isTouched || isDirty) && question.required" class="alert alert-danger">
                  <span class="text-label">Select one or more options</span>
                </div>
              </div>
            </div>

            <div *ngSwitchCase="'checklist'" class="form-check pad-top pad-right pad-left">
                <div class="row">
                  <div *ngIf="!shouldIndent" class="column1 question-label">
                    <span *ngIf="isNumbered && !isSubnumbered">{{qId}}.</span>
                    <span *ngIf="isNumbered && isSubnumbered">{{qId}} (i).</span>
                    <span *ngIf="!isNumbered && !isSubnumbered"></span>
                    <span *ngIf="!isNumbered && isSubnumbered">{{qId}} (i).</span>
                  </div>
                  <div class="column2 question-label">{{question.label}}<span *ngIf="required" style="color: red;">*</span></div>
                </div>
                <div *ngIf="isNumbered" class="pad-left-more pad-top-half">
                  <div *ngFor="let option of question.options; index as idx" [formArrayName]="question.key">
                    <ng-container *ngIf="idx === 0; else notChecked">
                       <div class="row">
                         <div class="column1">
                           <input type="checkbox" [formControlName]="idx" [id]="option.key" (click)="onSelected($event, question)" (click)="onSelected($event, question)"
                             class="form-check-input" checked>
                         </div>
                         <div class="column2">
                           <label [for]="option.key" class="form-check-label">
                             <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-container>
                    <ng-template #notChecked>
                       <div class="row">
                         <div class="column1">
                           <input type="checkbox" [formControlName]="idx" [id]="option.key" (click)="onSelected($event, question)" (click)="onSelected($event, question)"
                             class="form-check-input">
                         </div>
                         <div class="column2">
                           <label [for]="option.key" class="form-check-label">
                            <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-template>
                  </div>
                </div>
                <div *ngIf="!isNumbered" class="pad-top-half">
                  <div *ngFor="let option of question.options; index as idx" [formArrayName]="question.key">
                    <ng-container *ngIf="idx === 0; else notChecked">
                       <div class="row">
                         <div class="column1">
                           <input type="checkbox" [formControlName]="idx" [id]="option.key" (click)="onSelected($event, question)" (click)="onSelected($event, question)"
                             class="form-check-input" checked>
                         </div>
                         <div class="column2">
                           <label [for]="option.key" class="form-check-label">
                             <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-container>
                    <ng-template #notChecked>
                       <div class="row">
                         <div class="column1">
                           <input type="checkbox" [formControlName]="idx" [id]="option.key" (click)="onSelected($event, question)" (click)="onSelected($event, question)"
                             class="form-check-input">
                         </div>
                         <div class="column2">
                           <label [for]="option.key" class="form-check-label">
                            <span class="text-label">{{option.value}}</span>
                           </label>
                         </div>
                       </div>
                    </ng-template>
                  </div>
                </div>
                <div *ngIf="!submitted && !isValid && (isTouched || isDirty) && question.required" class="alert alert-danger">
                  <span class="text-label">Select one or more options</span>
                </div>
            </div>

            <div *ngSwitchCase="'boolean'" class="form-check pad-top">
              <div>
                <ng-container>
                    <div *ngIf="!shouldIndent" class="pad-left-more">
                       <div class="row">
                          <div class="column1">
                            <input class="text-label" type="checkbox" [formControlName]="question.key" (click)="onClick($event, question)"
                               id="{{question.key}}" [value]="selectedOption">
                          </div>
                          <div class="column2">
                            <label for="{{question.key}}"
                               class="form-check-label">
                               <span class="text-label" [innerHTML]="question.label"></span></label>
                          </div>
                       </div>
                    </div>
                    <div *ngIf="shouldIndent">
                       <div class="row">
                          <div class="column1">
                            <input class="text-label" type="checkbox" [formControlName]="question.key" (click)="onClick($event, question)"
                               id="{{question.key}}" [value]="selectedOption">
                          </div>
                          <div class="column2">
                            <label for="{{question.key}}"
                               class="form-check-label">
                               <span class="text-label" [innerHTML]="question.label"></span></label>
                          </div>
                       </div>
                    </div>
                </ng-container>
                <div *ngIf="!submitted && !isValid && (isTouched || isDirty) && question.required" class="alert alert-danger">
                  <br/>
                  <span class="pad-left-more pad-top-more text-label">Tick this box to proceed</span>
                </div>
              </div>
            </div>

            <!-- <div *ngSwitchCase="'dropdown'">
                <label>
                    {{question.label}}
                    <select [id]="question.key" [formControlName]="question.key">
                        <option *ngFor="let opt of question.options" [value]="opt.key">{{opt.value}}</option>
                    </select>
                </label>
            </div> -->

        </div>
    </div>
</div>
